import React from 'react';

import { ModalMultiDiscountComponent } from './ModalMultiDiscountComponent';
import { ModalConditionsComponent } from './ModalConditionsComponent';

import { InterstitialModalMetadataContainer } from './ModalMetaDataComponentStyle';

export const ModalMetaDataComponent = ({ i18n, REFUND, partner, coupon, discounts }) => (
    <InterstitialModalMetadataContainer>
        <p className="bold">{i18n.CONDITIONS_TITLE}</p>
        <div className="grid-2 has-gutter">
            <ModalConditionsComponent partner={partner} coupon={coupon} i18n={i18n} />
            <ModalMultiDiscountComponent partner={partner} discounts={discounts} REFUND={REFUND} />
        </div>
    </InterstitialModalMetadataContainer>
);



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/metadata/ModalMetaDataComponent.js